import React, { useContext, useEffect, useState } from 'react';
import { Alert, Space, Typography } from 'antd';
import Modal from '../../Modal';
import PosButton from '../../PosButton';
import { LogoutOutlined } from '@ant-design/icons';
import { WS_CLOSE_REASON } from '../../../api/ws';
import { BaseInfoContext } from '@/context/BaseInfoContext';
import { useLogout } from '@/utils/app';

const KickAwayModal: React.FC<{
  reason: WS_CLOSE_REASON;
}> = ({ reason }) => {
  const [{ userName }] = useContext(BaseInfoContext);
  const [hasLogout, setHasLogout] = useState(false);
  const { logout: logoutSilent } = useLogout({ silent: true });
  const { logout } = useLogout({ silent: true });
  if (!reason) {
    return null;
  }

  useEffect(() => {
    logoutSilent().then(() => {
      setHasLogout(true);
    });
  }, []);

  return (
    <Modal
      destroyOnHidden
      open={true}
      closable={false}
      closeIcon={null}
      style={{ background: 'transparent', overflow: 'hidden', borderRadius: 6, padding: 0 }}
      styles={{ body: { padding: 0 } }}
      footer={null}>
      <Alert
        type={'warning'}
        showIcon
        message={'您已在其它设备登录'}
        description={
          <>
            <Typography.Paragraph>
              系统检测到您的当前账户 <Typography.Text strong>{userName}</Typography.Text>{' '}
              在其它设备登录
              <br />
              已从当前设备自动退出
              <br />
              您可使用当前账户重新登录，或更换登录账户
            </Typography.Paragraph>
            <Space direction={'horizontal'} size={20}>
              <PosButton
                type={'primary'}
                ghost
                icon={<LogoutOutlined />}
                onClick={() => {
                  if (hasLogout) {
                    window.location.reload();
                  } else {
                    logout().then(() => {
                      window.location.reload();
                    });
                  }
                }}>
                退出
              </PosButton>
            </Space>
          </>
        }
      />
    </Modal>
  );
};

export default KickAwayModal;
